/**
 * Animation d'incrémentation pour les widgets statistiques
 */
(function() {
    'use strict';

    var easingFunctions = {
        linear: function(t) {
            return t;
        },
        easeOut: function(t) {
            return t * (2 - t);
        },
        easeInOut: function(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        }
    };

    function animateValue(element, start, end, duration, easingFunc) {
        var startTime = null;

        function animation(currentTime) {
            if (!startTime) startTime = currentTime;
            var elapsed = currentTime - startTime;
            var progress = Math.min(elapsed / duration, 1);
            var easedProgress = easingFunc(progress);
            var current = Math.floor(start + (end - start) * easedProgress);
            element.textContent = current < 10000 ? current.toString() : current.toLocaleString('fr-FR', { useGrouping: true });

            if (progress < 1) {
                requestAnimationFrame(animation);
            }
        }

        requestAnimationFrame(animation);
    }

    function initStatsWidget(card) {
        if (!card) return;

        var duration = parseInt(card.dataset.duration) || 2000;
        var easing = card.dataset.easing || 'easeOut';
        var easingFunc = easingFunctions[easing] || easingFunctions.easeOut;

        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var valueEl = card.querySelector('.krg-stat-value');
                    if (valueEl && !valueEl.dataset.animated) {
                        var target = parseInt(valueEl.dataset.target) || 0;
                        animateValue(valueEl, 0, target, duration, easingFunc);
                        valueEl.dataset.animated = 'true';
                    }
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.3
        });

        observer.observe(card);
    }

    // Initialisation au chargement du DOM
    function initAllStatsWidgets() {
        var cards = document.querySelectorAll('.krg-stat-card');
        cards.forEach(function(card) {
            initStatsWidget(card);
        });
    }

    // Attendre que le DOM soit prêt
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllStatsWidgets);
    } else {
        initAllStatsWidgets();
    }

    // Exposer pour réinitialiser après ajout dynamique (Elementor editor)
    window.krgInitStatsWidget = initStatsWidget;
})();


